module.exports = __webpack_public_path__ + "static/the-moon-is-a-harsh-mistress-35238166e1da5cc8c576d750e0445056.jpg";